import React from "react";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function BranchDetails({
    label,
    branchName,
    isEditable,
    branchOptions,
    organizationId,
    onChange,
}) {
    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                selectedValue={branchName}
                isEditable={isEditable}
                onSelectChange={onChange}
                options={{
                    ...branchOptions,
                    url: `${branchOptions.url}`,
                    filterResource: `filter[organizationId]=${organizationId}`,
                }}
                type="dropdown"
            />
        </EuiFlexItem>
    );
}
